import * as React from 'react';

import {LoadingPage} from 'shells/loading-page/loading-page';
import {Quote} from 'shells/sales-documents/quote';

import type {
    GetQuoteById_quote as QuoteType,
    SalesDocumentUpdateInput,
    QuoteProductsUpdateInput,
    QuoteSubtotalItemsUpdateInput,
} from 'nutshell-graphql-types';

import {
    useUpdateQuote,
    useUpdateQuoteProduct,
    useUpdateQuoteTemplate,
    useUpdateQuoteTemplateProduct,
    useGetPossibleProducts,
    useUpdateQuoteSubtotal,
    useGetUserNames,
} from '../shared/graphql/hooks';

type Props = {
    quote: QuoteType;
    isTemplate: boolean;
    toggleHasActiveSection: (isActive: boolean) => void;
};

export function QuoteWrapper(props: Props) {
    const {users, isLoading} = useGetUserNames(props.isTemplate);
    const {quotePossibleProducts} = useGetPossibleProducts(props.quote.id, props.isTemplate);

    const {updateQuote} = useUpdateQuote();
    const {updateQuoteProduct} = useUpdateQuoteProduct();
    const {updateQuoteTemplate} = useUpdateQuoteTemplate();
    const {updateQuoteTemplateProduct} = useUpdateQuoteTemplateProduct();
    const {updateQuoteSubtotal} = useUpdateQuoteSubtotal();

    const handleSaveQuote = (quote: SalesDocumentUpdateInput) => {
        if (props.isTemplate) {
            updateQuoteTemplate(quote);
        } else {
            updateQuote(quote);
        }
    };

    const handleSaveProductTable = (quote: QuoteProductsUpdateInput) => {
        if (props.isTemplate) {
            updateQuoteTemplateProduct(quote);
        } else {
            updateQuoteProduct(quote);
        }
    };

    const handleSaveSubtotalTable = (quote: QuoteSubtotalItemsUpdateInput) => {
        updateQuoteSubtotal(quote);
    };

    if (!users && !props.isTemplate) {
        return (
            <div className='absolutely-center-and-fill'>
                <LoadingPage />
            </div>
        );
    }

    return (
        props.quote && (
            <Quote
                quote={props.quote}
                handleSaveQuote={handleSaveQuote}
                handleSaveProductTable={handleSaveProductTable}
                quotePossibleProductsEdges={quotePossibleProducts}
                handleSaveSubtotalTable={handleSaveSubtotalTable}
                isTemplate={props.isTemplate}
                users={users}
                isLoading={isLoading}
                toggleHasActiveSection={props.toggleHasActiveSection}
            />
        )
    );
}
